import React, {useEffect} from "react";
import {
    AppBar,
    Paper,
    Container,
    Box,
    CssBaseline,
    Toolbar,
    Typography, Alert
} from "@mui/material";

import IconButton from '@mui/material/IconButton';
import Menu from '@mui/material/Menu';
import MenuIcon from '@mui/icons-material/Menu';
import Avatar from '@mui/material/Avatar';
import Button from '@mui/material/Button';
import Tooltip from '@mui/material/Tooltip';
import MenuItem from '@mui/material/MenuItem';
import AdbIcon from '@mui/icons-material/Adb';
import {logout} from "../../features/users/Users";
import {Link, NavLink, useSearchParams} from "react-router-dom";
import {useSelector} from "react-redux";
import Logo from "../Logo";
import {red} from "@mui/material/colors";
import {
    AccountBalance, AutoMode,
    Bolt, Check, CircleNotifications,
    Grading,
    Group,
    MonetizationOn,
    QueryStats, ShoppingCart,
    SmartToy,
    TableView, ViewList, Category, Block, TrendingUp, Insights
} from "@mui/icons-material";

import UrlChecker from "../UrlChecker";

const pages = [
    {
        name: 'Dashboard',
        route: '/dashboard',
        admin: false
    },
    {
        name: 'Supply Feeds',
        route: '/supply/feeds',
        admin: false
    },
    {
        name: 'Checker',
        route: '/?checker=true',
        admin: true
    },
    {
        name: 'Users',
        route: '/users',
        admin: true
    },
    {
        name: 'Demand Feeds',
        route: '/demand/feeds',
        admin: true
    },
    {
        name: 'Invoice Closing',
        route: '/invoices/closing',
        admin: true
    },
    {
        name: 'Demand Stats',
        route: '/demand/stats',
        admin: true
    },
    {
        name: 'Supply Stats',
        route: '/admin/supply',
        admin: true
    },
    {
        name: 'Admin Supply Feeds',
        route: '/admin/feeds',
        admin: true
    },
    {
        name: 'Alerts',
        route: '/admin/alerts',
        admin: true
    },
    {
        name: 'Mediabuying',
        route: '/admin/mediabuying',
        admin: true
    },
    {
        name: 'Media Buying Reports',
        route: '/admin/mediabuying/reports',
        admin: true
    },
    {
        name: 'Spin Feeds',
        route: '/spin/list',
        admin: true
    }
];
const settings = [

    {
        name: 'Invoices',
        route: '/invoices',
        admin: false
    },
    {
        name: 'Billing Info & Payment Methods',
        route: '/billing',
        admin: false
    },
    {
        name: 'Settings',
        route: '/user/settings',
        admin: false
    },
];

function MainLayout({children, title}) {


    const userName = useSelector((state) => state.users.name)
    const userIsAdmin = useSelector((state) => state.users.is_admin)
    const [openUrlChecker, setOpenUrlChecker] = React.useState(false);
    let [searchParams, setSearchParams] = useSearchParams();


    const [anchorEl, setAnchorEl] = React.useState(null);
    const open = Boolean(anchorEl);
    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
    };
    const handleClose = () => {
        setAnchorEl(null);
    };

    useEffect(() => {

        if (searchParams.get('checker')) {
            setOpenUrlChecker(true)
        }

    }, [searchParams]);

    const [anchorElNav, setAnchorElNav] = React.useState(null);
    const [anchorElUser, setAnchorElUser] = React.useState(null);

    const handleOpenNavMenu = (event) => {
        setAnchorElNav(event.currentTarget);
    };
    const handleOpenUserMenu = (event) => {
        setAnchorElUser(event.currentTarget);
    };

    const handleCloseNavMenu = () => {
        setAnchorElNav(null);
    };

    const handleCloseUserMenu = () => {
        setAnchorElUser(null);
    };

    return (
        // Viewport-tall flex column: the static AppBar plus a <main> that takes the rest and is THE scroller. Before, <main>
        // was 100vh on its own under a 56/64 px AppBar, so the document was taller than the screen and the bottom of every
        // page sat below the fold (on iOS Safari also under the toolbar, because 100vh there is the large viewport). With
        // overscroll-behavior: contain on <main> that strip could never be reached by scrolling. dvh follows the toolbar.
        <Box sx={{display: "flex", flexDirection: "column", height: "100vh", "@supports (height: 100dvh)": {height: "100dvh"}}}>
            <AppBar position="static" sx={{flex: "0 0 auto"}}>
                <Container maxWidth="xl">
                    <Toolbar disableGutters>

                        <Typography
                            variant="h6"
                            noWrap
                            href="/"
                            sx={{
                                mr: 2,
                                display: {xs: 'none', md: 'flex'},
                                fontWeight: 700,
                                letterSpacing: '.3rem',
                                color: 'inherit',
                                textDecoration: 'none',
                            }}
                        >
                            <Link to='/dashboard' style={{color: 'white', textDecoration: "none"}}>
                                <Logo/>
                            </Link>
                        </Typography>

                        <Box sx={{flexGrow: 1, display: {xs: 'flex', md: 'none'}}}>
                            <IconButton
                                size="large"
                                aria-label="account of current user"
                                aria-controls="menu-appbar"
                                aria-haspopup="true"
                                onClick={handleOpenNavMenu}
                                color="inherit"
                            >
                                <MenuIcon/>
                            </IconButton>
                            <Menu
                                id="menu-appbar"
                                anchorEl={anchorElNav}
                                anchorOrigin={{
                                    vertical: 'bottom',
                                    horizontal: 'left',
                                }}
                                keepMounted
                                transformOrigin={{
                                    vertical: 'top',
                                    horizontal: 'left',
                                }}
                                open={Boolean(anchorElNav)}
                                onClose={handleCloseNavMenu}
                                sx={{
                                    display: {xs: 'block', md: 'none'},
                                }}
                            >


                                {pages.map((page) => {

                                    if (!page.admin || userIsAdmin)
                                        return (


                                            <MenuItem key={page.name} onClick={handleCloseNavMenu}>
                                                <NavLink
                                                    to={page.route}
                                                    style={({isActive}) =>
                                                        isActive
                                                            ? {
                                                                color: 'black', textDecoration: "none", fontWeight: "bolder"

                                                            }
                                                            : {color: 'black', textDecoration: "none"}
                                                    }
                                                >
                                                    {page.name}
                                                </NavLink>
                                            </MenuItem>

                                        )
                                })}

                            </Menu>
                        </Box>
                        <Typography
                            variant="h5"
                            noWrap
                            sx={{
                                mr: 2,
                                display: {xs: 'flex', md: 'none'},
                                flexGrow: 1,
                                fontWeight: 700,
                                letterSpacing: '.3rem',
                                color: 'inherit',
                                textDecoration: 'none',
                            }}
                        >

                            <Link to='/dashboard' style={{color: 'white', textDecoration: "none"}}>
                                <Logo/>
                            </Link>
                        </Typography>
                        <Box sx={{flexGrow: 1, display: {xs: 'none', md: 'flex'}}}>


                            {pages.map((page) => {

                                if (!page.admin)
                                    return (

                                        <Button
                                            key={page.name}
                                            onClick={handleCloseNavMenu}
                                            sx={{my: 2, color: 'white', display: 'block'}}
                                        >

                                            <NavLink
                                                to={page.route}
                                                style={({isActive}) =>
                                                    isActive
                                                        ? {
                                                            color: 'white', textDecoration: "none", fontWeight: "bolder"

                                                        }
                                                        : {color: 'white', textDecoration: "none"}
                                                }
                                            >
                                                {page.name}
                                            </NavLink>
                                        </Button>
                                    )
                            })}
                            {userIsAdmin && <div>
                                <Button
                                    key={"admin-stuff"}
                                    id="basic-button"
                                    aria-controls={open ? 'basic-menu' : undefined}
                                    aria-haspopup="true"
                                    aria-expanded={open ? 'true' : undefined}
                                    onClick={handleClick}
                                    sx={{
                                        color: 'gold',
                                        fontWeight: 'bolder',
                                        my: 2,
                                        mr: 2,
                                        borderBottom: 2,
                                        borderRadius: 0,

                                        background: "transparent"
                                    }}
                                    startIcon={<Bolt/>}
                                    endIcon={<Bolt/>}

                                >
                                    Admin Stuff
                                </Button>
                                <Menu
                                    id="basic-menu"
                                    anchorEl={anchorEl}
                                    open={open}
                                    onClose={handleClose}
                                    MenuListProps={{
                                        'aria-labelledby': 'basic-button',
                                    }}
                                >

                                    <MenuItem onClick={() => {
                                        searchParams.set("checker", true);
                                        setSearchParams(searchParams);
                                        handleClose()
                                    }}><SmartToy sx={{mr: 1}}/>Url Checker</MenuItem>
                                    <MenuItem onClick={handleClose} component={Link} to="/users"><Group sx={{mr: 1}}/>Users</MenuItem>
                                    <MenuItem onClick={handleClose} component={Link} to="/demand/feeds"><MonetizationOn
                                        sx={{mr: 1}}/>Demand Feeds</MenuItem>
                                    <MenuItem onClick={handleClose} component={Link} to="/demand/stats"><TableView
                                        sx={{mr: 1}}/>Demand Stats</MenuItem>
                                    <MenuItem onClick={handleClose} component={Link}
                                              to="/invoices/closing"><AccountBalance sx={{mr: 1}}/>Closing</MenuItem>
                                    <MenuItem onClick={handleClose} component={Link} to="/admin/supply"><Grading
                                        sx={{mr: 1}}/>Supply Stats</MenuItem>
                                    <MenuItem onClick={handleClose} component={Link} to="/admin/feeds"><ViewList
                                        sx={{mr: 1}}/>Admin Supply Feeds</MenuItem>
                                    <MenuItem onClick={handleClose} component={Link} to="/admin/alerts"><CircleNotifications
                                        sx={{mr: 1}}/>Alerts</MenuItem>
                                    <MenuItem onClick={handleClose} component={Link} to="/admin/mediabuying">
                                        <ShoppingCart sx={{mr: 1}}/>Mediabuying
                                    </MenuItem>
                                    <MenuItem onClick={handleClose} component={Link} to="/mediabuying/keywords">
                                        <Category sx={{mr: 1}}/>Keywords
                                    </MenuItem>
                                    <MenuItem onClick={handleClose} component={Link} to="/spin/list"><AutoMode
                                        sx={{mr: 1}}/>Spin Feeds</MenuItem>
                                    <MenuItem onClick={handleClose} component={Link} to="/admin/blacklist">
                                        <Block sx={{mr: 1}}/>Mixer Blacklists
                                    </MenuItem>
                                    <MenuItem onClick={handleClose} component={Link} to="/rsoc/generator">
                                        <AutoMode sx={{mr: 1}}/>RSOC Generator
                                    </MenuItem>
                                    <MenuItem onClick={handleClose} component={Link} to="/admin/feed-performance"><TrendingUp sx={{mr: 1}}/>Feed Performance</MenuItem>
                                    <MenuItem onClick={handleClose} component={Link} to="/admin/traffic-control"><Insights sx={{mr: 1}}/>Traffic Control</MenuItem>
                                    <MenuItem onClick={handleClose} component={Link} to="/admin/conversions"><TrendingUp sx={{mr: 1}}/>Conversions</MenuItem>
                                    <MenuItem onClick={handleClose} component={Link} to="/admin/rotators"><AutoMode sx={{mr: 1}}/>Rotators</MenuItem>
                                </Menu>
                            </div>}
                        </Box>
                        <Box sx={{flexGrow: 0}}>


                        </Box>


                        <Box sx={{flexGrow: 0}}>
                            <Tooltip title="Open settings">
                                <IconButton onClick={handleOpenUserMenu} sx={{p: 0}}>
                                    <Avatar alt={userName} src="#"/>
                                </IconButton>
                            </Tooltip>
                            <Menu
                                sx={{mt: '45px'}}
                                id="menu-appbar"
                                anchorEl={anchorElUser}
                                anchorOrigin={{
                                    vertical: 'top',
                                    horizontal: 'right',
                                }}
                                keepMounted
                                transformOrigin={{
                                    vertical: 'top',
                                    horizontal: 'right',
                                }}
                                open={Boolean(anchorElUser)}
                                onClose={handleCloseUserMenu}
                            >

                                {settings.map((setting) => (
                                    <MenuItem key={setting.name} onClick={handleCloseUserMenu}>
                                        <Link to={setting.route} style={{
                                            color: 'black',
                                            textDecoration: 'none',
                                            display: 'block',
                                            width: '100%',
                                        }}>{setting.name}</Link>
                                    </MenuItem>
                                ))}
                                <MenuItem key={"logout"} onClick={handleCloseUserMenu}>
                                    <Typography style={{
                                        color: 'black',
                                        textDecoration: 'none',
                                        display: 'block',
                                        width: '100%',
                                    }} onClick={logout}>Logout</Typography>
                                </MenuItem>
                            </Menu>
                        </Box>
                    </Toolbar>
                </Container>
            </AppBar>
            {openUrlChecker && <UrlChecker setOpen={setOpenUrlChecker} open={openUrlChecker}/>}

            <Box
                component="main"
                sx={{
                    backgroundColor: (theme) =>
                        theme.palette.mode === 'light'
                            ? theme.palette.grey[100]
                            : theme.palette.grey[900],
                    flex: '1 1 auto',
                    minHeight: 0,
                    overflow: 'auto',
                }}
            >
                {children}
            </Box>
        </Box>
    )
}

export default MainLayout